import { useAuth } from 'react-oidc-context';

import AutoSignin from '@/features/auth/components/auto-signin';
import { AccountType, setAccountType } from '@/utils/account-type';

const FuturesRegisterPage = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    window.location.assign(import.meta.env.VITE_APP_EXCHANGE_URL);
    return null;
  }

  setAccountType(AccountType.FUTURES);

  return (
    <AutoSignin
      args={{
        extraQueryParams: {
          screen_hint: 'signup',
        },
      }}
    />
  );
};
FuturesRegisterPage.displayName = 'FuturesRegisterPage';

export default FuturesRegisterPage;
